/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { OverrideData, UnblockSlotsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    unblockSlots: build.mutation<OverrideData, UnblockSlotsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/slots/unblock`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as unblockSlotsApi };
export const { useUnblockSlotsMutation } = injectedRtkApi;
